import * as React from "react";
import styled from "styled-components";

import { createEntitiesConsumer } from "../../lib/entities";
import { Image } from "../../entities";
import { Post } from "../entities";
import { colors, truncateLines } from "../../common/utils/style";
import Icon from "../../common/components/Icon";
import Img from "../../common/components/Image";

interface Props {
  post: Post;
  isSelected: boolean;
  onClick?: (post: Post) => void;
  showStatus?: boolean;
  className?: string;
}

const ImageEntitiesConsumer = createEntitiesConsumer<{ image: Image }>({ image: "images" });

class PostSelectBoxItem extends React.PureComponent<Props> {
  public static defaultProps: Partial<Props> = {
    showStatus: false,
  };

  public base: HTMLElement | null = null;

  public focus() {
    if (this.base) {
      this.base.focus();
    }
  }

  public onSelect = () => {
    const { onClick, post } = this.props;
    if (onClick) {
      onClick(post);
    }
  };

  public render() {
    const { post, isSelected, showStatus, className } = this.props;
    return (
      <Base
        role="switch"
        aria-checked={isSelected}
        tabIndex={0}
        onKeyPress={this.onSelect}
        onClick={this.onSelect}
        innerRef={r => (this.base = r)}
        className={className}
      >
        <ThumbnailWrapper>
          <ImageEntitiesConsumer query={{ image: post.image }}>
            {({ image }) => (image ? <Thumbnail image={image} alt={post.title} size="44x44#" background /> : null)}
          </ImageEntitiesConsumer>
        </ThumbnailWrapper>
        <Title>{post.title}</Title>
        {showStatus ? <Status>{isSelected && <StatusIcon name="wt-icon-check" />}</Status> : null}
      </Base>
    );
  }
}

const Base = styled.div`
  margin: 4px 12px;
  padding: 8px;
  display: flex;
  background-color: white;
  border-radius: 2px;
  cursor: pointer;
  &:focus,
  &:hover {
    outline: none;
    background: ${colors.lightergray2};
  }
`;

const ThumbnailWrapper = styled.div`
  width: 44px;
  height: 44px;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 2px;
  overflow: hidden;
  background-color: ${colors.lightergray2};
`;

const Thumbnail = styled(Img)`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;

const Title = styled.div`
  ${truncateLines(3, 12, 1.25)};
  font-weight: 600;
  color: ${colors.gray3};
`;

const Status = styled.div`
  position: relative;
  width: 30px;
  margin-left: auto;
  flex-shrink: 0;
`;

const StatusIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 4px;
  font-size: 18px;
  display: block;
  border-radius: 50%;
  box-sizing: border-box;
  color: ${colors.blue1};
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export default PostSelectBoxItem;



// WEBPACK FOOTER //
// ./frontend/src/posts/components/PostSelectBoxItem.tsx